export const environment = {
    production: true,
    apiUrl: 'https://digihous.com.br:443', // URL da API para produção
  };